import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { publishViewCarsDivHeight } from "../../../../../../redux/features/cars/carsSlice";

const ViewCars = ({ onViewCarsCallback }: { onViewCarsCallback: Function }) => {
  const carPrizes = useAppSelector(state => state.cars.filteredList);
  const dispatch = useAppDispatch();
  const ref = useRef<HTMLDivElement>();

  useEffect(() => {
    if (ref.current) {
      dispatch(publishViewCarsDivHeight({ value: ref.current.clientHeight }));
    }
  }, []);

  return (
    <div className="fixed bottom-0 left-0 right-0 w-full viewFilteredCars" data-testid="viewCarsDiv" ref={ref}>
      <div className="flex justify-center p-4 shadow-[0_-2px_8px_-1px_#ece6e6]">
        <button
          className="bg-[#FF8200] text-white font-semibold py-2 px-12 border border-orange-500 rounded"
          onClick={() => onViewCarsCallback(false)}>
          VIEW {carPrizes.length} CARS
        </button>
      </div>
    </div>
  );
};

export default ViewCars;
